interface Props {
  unreadCount: number;
  totalCount: number;
}

const NotificationHeader: React.FC<Props> = ({
  unreadCount,
  totalCount,
}) => (
  <div className="flex items-center justify-between border-b border-stroke px-4.5 py-3 dark:border-strokedark">
    {/* 🧾 Título */}
    <div className="flex flex-col">
      <h5 className="text-sm font-semibold text-black dark:text-white">
        Notificaciones
      </h5>

      <span className="text-xs text-body dark:text-bodydark">
        Centro de actividad del sistema
      </span>
    </div>

    {/* 🔢 Resumen */}
    <div className="flex flex-col items-end">
      <span className="text-sm font-semibold text-primary">
        {unreadCount}
      </span>

      <span className="text-xs text-body dark:text-bodydark">
        de {totalCount} total
      </span>
    </div>
  </div>
);

export default NotificationHeader;